var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tooltip',{attrs:{"disabled":_vm.text && _vm.text.length< _vm.length,"effect":"light","content":_vm.text,"placement":"top-start"}},[_c('div',{staticClass:"ellipsis-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }